import { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import {
  registerToastController,
  unregisterToastController,
} from "./toastService";

function PrimeToastProvider() {
  const toastRef = useRef(null);

  useEffect(() => {
    const controller = {
      show: (message) => toastRef.current?.show(message),
      remove: (message) => toastRef.current?.remove(message),
      clear: () => toastRef.current?.clear(),
    };

    registerToastController(controller);
    return () => unregisterToastController(controller);
  }, []);

  return <Toast ref={toastRef} position="bottom-right" className="ls-prime-toast" />;
}

export default PrimeToastProvider;
